// Mock for @react-native-async-storage/async-storage
import moduleUtils from './module-mock';

const { createMockComponent } = moduleUtils;

// Create specific mock components for this module
const Component = createMockComponent('async-storage');

// Export components and utilities
export default Component;
export const otherExport = {};
